import { useSelector } from 'react-redux';

import { Root } from '@service/reducers';

export const useBreakpoints = () => {
  const system = useSelector((store: Root) => store.system);
  return { isMobile: system.isMobile, isTable: system.isTable, isDesktop: system.isDesktop };
};
